var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.visible,
        width: "40%",
        "modal-append-to-body": "",
        "append-to-body": "",
        "close-on-click-modal": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        closed: _vm.handleClose,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            size: "small",
            model: _vm.form,
            rules: _vm.rules,
            "label-width": "80px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "指定渠道", prop: "channelIds" } },
            [
              _c("el-input", {
                attrs: { type: "textarea" },
                on: {
                  focus: function ($event) {
                    return _vm.channelInputClick(_vm.item)
                  },
                },
                model: {
                  value: _vm.form.channelIds,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "channelIds", $$v)
                  },
                  expression: "form.channelIds",
                },
              }),
              _c("channel-popups", {
                attrs: {
                  isAppendToBody: true,
                  modelIsAppendToBody: false,
                  "app-id": _vm.form.channels.channelId,
                  visible: _vm.channelVisible,
                  multiple: false,
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.channelVisible = $event
                  },
                  comfirm: function ($event) {
                    return _vm.channelConfirm($event, _vm.item)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "标签", prop: "label" } },
            [
              _c(
                "el-select",
                {
                  attrs: { size: "small", placeholder: "标签", clearable: "" },
                  model: {
                    value: _vm.form.label,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "label", $$v)
                    },
                    expression: "form.label",
                  },
                },
                [_c("el-option", { attrs: { label: "白名单", value: "1" } })],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "备注", prop: "remark" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  "show-limit-word": "",
                  maxlength: "9999",
                  placeholder: "请输入说明",
                  clearable: "",
                },
                model: {
                  value: _vm.form.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "remark", $$v)
                  },
                  expression: "form.remark",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.hide } },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary", loading: _vm.loading },
              on: { click: _vm.save },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }